<script lang="ts">
    import { fade } from 'svelte/transition';
    import { createTooltip, melt } from '@melt-ui/svelte';
    import type { FloatingConfig } from '@melt-ui/svelte/internal/actions';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import { cx } from '$lib/utils/cx';

    export let openDelay: number | undefined = undefined;
    export let closeDelay: number | undefined = undefined;

    export let positioning: FloatingConfig | undefined = undefined;

    export let zIndex: number | 'current' | 'inc' = 1070;
    const {
        elements: { trigger, content, arrow },
        states: { open },
    } = createTooltip({
        positioning: positioning,
        openDelay,
        closeDelay,
        closeOnPointerDown: false,
        forceVisible: false,
    });

    export let tooltip: string | null | undefined = null;
    export let tooltipClass: string = '';
</script>

<StackZIndex {zIndex} let:zIndex>
    <slot trigger={$trigger} />

    {#if $open}
        <div
            use:melt={$content}
            class={cx('tooltip-inner z-[--z-index]', tooltipClass)}
            in:fade={{ duration: 100 }}
            style={`--z-index: ${zIndex + 1}`}
        >
            <slot name="tooltip">{tooltip ?? ''}</slot>
            <div use:melt={$arrow} />
        </div>
    {/if}
</StackZIndex>
